const FETCH_MY_QUIZZES_REQUEST = 'my-quizzes/FETCH_MY_QUIZZES_REQUEST';
const FETCH_MY_QUIZZES_SUCCESS = 'my-quizzes/FETCH_MY_QUIZZES_SUCCESS';
const FETCH_INFINITE_MY_QUIZZES_SUCCESS = 'my-quizzes/FETCH_INFINITE_MY_QUIZZES_SUCCESS';
const FETCH_MY_QUIZZES_FAILURE = 'my-quizzes/FETCH_MY_QUIZZES_FAILURE';
const SET_QUIZ_REQUEST = 'my-quizzes/SET_QUIZ_REQUEST';
const SET_QUIZ_SUCCESS = 'my-quizzes/SET_QUIZ_SUCCESS';
const SET_QUIZ_FAILURE = 'my-quizzes/SET_SET_QUIZ_FAILURE';
const PUT_QUIZ_REQUEST = 'my-quizzes/PUTQUIZ_REQUEST';
const PUT_QUIZ_SUCCESS = 'my-quizzes/PUT_QUIZ_SUCCESS';
const PUT_QUIZ_FAILURE = 'my-quizzes/PUT_QUIZ_FAILURE';
const DELETE_QUIZ_REQUEST = 'my-quizzes/DELETE_QUIZ_REQUEST';
const DELETE_QUIZ_SUCCESS = 'my-quizzes/DELETE_QUIZ_SUCCESS';
const DELETE_QUIZ_FAILURE = 'my-quizzes/DELETE_QUIZ_FAILURE';

export default {
  FETCH_MY_QUIZZES_REQUEST,
  FETCH_MY_QUIZZES_SUCCESS,
  FETCH_INFINITE_MY_QUIZZES_SUCCESS,
  FETCH_MY_QUIZZES_FAILURE,
  SET_QUIZ_REQUEST,
  SET_QUIZ_SUCCESS,
  SET_QUIZ_FAILURE,
  PUT_QUIZ_REQUEST,
  PUT_QUIZ_SUCCESS,
  PUT_QUIZ_FAILURE,
  DELETE_QUIZ_REQUEST,
  DELETE_QUIZ_SUCCESS,
  DELETE_QUIZ_FAILURE,
};



// WEBPACK FOOTER //
// ./src/app/my-quizzes/store/mutation-types.js